import { Checkbox } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { ReactComponent as CheckeBoxOutlineIcon } from './Assets/checkBoxOutline.svg'
import { ReactComponent as CheckedBoxIcon } from './Assets/checkBox.svg'
import { ReactComponent as CorrectIcon } from './Assets/correct.svg'

const DEFAULT_SIZE = 22

const CustomCheckedBox = ({ size = DEFAULT_SIZE }) => {
    const scale = size / DEFAULT_SIZE

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: `${size}px`,
                height: `${size}px`
            }}>
            <CheckedBoxIcon style={{ position: 'absolute', transform: `scale(${scale})` }} />
            <CorrectIcon style={{ position: 'absolute', transform: `scale(${scale})` }} />
        </div>
    )
}
const CustomCheckboxOutLine = ({ size = DEFAULT_SIZE }) => {
    const scale = size / DEFAULT_SIZE

    return (
        <div style={{ position: 'relative', width: `${size}px`, height: `${size}px` }}>
            <CheckeBoxOutlineIcon style={{ position: 'absolute', transform: `scale(${scale})`, transformOrigin: 'top left' }} />
        </div>
    )
}

const DefaultCheckboxSVG = observer(({ size, sx, ...props }) => {
    return (
        <Checkbox
            {...props}
            sx={{
                '&.Mui-disabled': {
                    '--checkbox-checked': 'var(--checkbox-disabled)',
                    '--checkbox-border': 'var(--checkbox-disabled)'
                },
                ...sx
            }}
            checkedIcon={<CustomCheckedBox size={size} />}
            icon={<CustomCheckboxOutLine size={size} />}
        />
    )
})

export default DefaultCheckboxSVG
